
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seedream-ai-image-generator",
      function () {
        return require("private-next-pages/seedream-ai-image-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seedream-ai-image-generator"])
      });
    }
  